import { jsx as _jsx } from "react/jsx-runtime";
/**
 * List + ListItem — vertical stack primitive (MA-05)
 */
import { forwardRef } from 'react';
import clsx from 'clsx';
export const List = forwardRef(({ className, ...rest }, ref) => (_jsx("ul", { ref: ref, className: clsx('m-0 flex list-none flex-col divide-y divide-neutral-100 p-0', className), ...rest })));
List.displayName = 'List';
export const ListItem = forwardRef(({ interactive = false, className, ...rest }, ref) => (_jsx("li", { ref: ref, className: clsx('min-h-12 px-3 py-3 text-body text-neutral-900', interactive &&
        'cursor-pointer rounded-md hover:bg-neutral-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary-500 focus-visible:ring-offset-2', className), ...rest })));
ListItem.displayName = 'ListItem';
//# sourceMappingURL=List.js.map